export default __webpack_public_path__ + "static/media/ArrowRightWhite.a275f049.svg";